import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Notice } from './models/notices.model';
import { NoticesType } from './models/notification-type.enum';

@Injectable({
  providedIn: 'root'
})
export class NoticesService {
  private readonly dataSource = new BehaviorSubject<Notice[]>([]);
  public readonly notices = this.dataSource.asObservable();

  /**
   * Muestra una notificación de éxito
   * @param title Texto a mostrar en la notificación
   * @param description Descripción a mostrar en la notificación
   * */
  showSuccess(title: string, description?: string): void {
    const successNotification = {
      type: NoticesType.SUCCESS,
      html: title,
      description: { html: description || '' }
    };
    this.addNotification(successNotification);
  }

  /**
   * Muestra una notificación informativa
   * @param title Texto a mostrar en la notificación
   * @param description Descripción a mostrar en la notificación
   */
  showInfo(title: string, description?: string): void {
    const infoNotification = {
      type: NoticesType.INFO,
      html: title,
      description: { html: description || '' }
    };
    this.addNotification(infoNotification);
  }

  /**
   * Muestra una notificación de alerta
   * @param title Texto a mostrar en la notificación
   * @param description Descripción a mostrar en la notificación
   */
  showAlert(title: string, description?: string): void {
    const warningNotification = {
      type: NoticesType.ALERT,
      html: title,
      description: { html: description || '' }
    };
    this.addNotification(warningNotification);
  }

  private addNotification(notification: Notice): void {
    // Evitamos duplicados al añadir
    const currentNotifications = this.dataSource.value;
    const isDuplicate = currentNotifications.some(
      (n) =>
        n.type === notification.type &&
        n.html === notification.html &&
        n.description?.html === notification.description?.html
    );
    if (!isDuplicate) {
      this.dataSource.next([...currentNotifications, notification]);
    }
  }

  close(index: number): void {
    const currentNotifications = this.dataSource.value;
    const updatedNotifications = currentNotifications.filter((_, i) => i !== index);
    this.dataSource.next(updatedNotifications);
  }

  closeAll(): void {
    this.dataSource.next([]);
  }

  get currentNotifications(): Notice[] {
    return this.dataSource.value;
  }
}
